export const dataTestIds = {
	table: 'software-board-settings-sortable-table.ui.sortable-table.table',
	queryListDragHandle:
		'software-board-settings-sortable-table.ui.query-list.drag-handle.drag-handle-button.button',
	queryListDragHandleMenu:
		'software-board-settings-query-sortable-table.ui.query-list.drag-handle.menu',
};
